
import React from 'react';
import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { JobSearchFormData } from '../../JobSearchFormSchema';

interface PostingRecencySelectProps {
  control: Control<JobSearchFormData>;
  isLoading: boolean;
}

export const PostingRecencySelect: React.FC<PostingRecencySelectProps> = ({
  control,
  isLoading,
}) => {
  return (
    <FormField
      control={control}
      name="maxPostedWeeks"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Maximum Posting Age</FormLabel>
          <FormControl>
            <Select
              value={field.value?.toString() || "any"}
              onValueChange={(value) => field.onChange(value === "any" ? undefined : parseInt(value))}
              disabled={isLoading}
            >
              <SelectTrigger>
                <SelectValue placeholder="Any time" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="any">Any time</SelectItem>
                <SelectItem value="1">Past week</SelectItem>
                <SelectItem value="2">Past 2 weeks</SelectItem>
                <SelectItem value="4">Past month</SelectItem>
                <SelectItem value="8">Past 2 months</SelectItem>
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
